import React from 'react'
import { isEmpty } from 'lodash'

const SecurityGroups = ({ groups }) => {
  if (isEmpty(groups)) return null
  return groups.map(group => <p key={group.vpcSecurityGroupId}>{`ID: ${group.vpcSecurityGroupId} - ${group.status}`}</p>)
}

export default SecurityGroups
